<template>
    <div class="ModifyHeadImg">
        <el-dialog :title="$t('myAccount.text98')" v-model="ModelFlag" width='450px' custom-class="modify"
            :close-on-click-modal="false" destroy-on-close @closed="beforeClose">
            <div class="modify_box">
                <div class="avatar">
                    {{ $t('myAccount.text99') }}
                </div>
                <div class="headImg">
                    <div class="update-avatar" :class="updataShow ? 'opacity' : ''" @mousemove="updataShow = true"
                        @mouseout="updataShow = false" @click="Update">
                        <img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/accountInformation/icon_upload%402x.png"
                            alt="">
                        <p>{{ $t('myAccount.text100') }}</p>
                    </div>
                    <img id="myImg" :src="headpicUrl" alt="">
                    <div class="head-img">
                        <div class="example-headImg" @click="chooseCaptionPhoto">
                            <input type="file" name="headImg" accept="image/*" capture="camera" class="upload-headImg"
                                ref="headImg">
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="ModelFlag = false">{{ $t('trade.text72') }}</el-button>
                    <el-button type="primary" :loading='loading' :disabled="!submitFlag"
                        @click="Confirm">{{ $t('trade.text73') }}</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import {
    ref, computed, inject, onBeforeUnmount
} from 'vue';
import { useStore } from 'vuex';
import $ from 'jquery';
import compressImg from '@/until/compressImage';
import apiService from '@/api/request';
import { ElMessage } from 'element-plus'
import { useI18n } from "vue-i18n";

export default {
    name: 'ModifyHeadImg',
    setup() {
        const ModelFlag = ref(false);
        const store = useStore();
        const emitt = inject('emitt');
        const { t } = useI18n()

        let headImgBase64 = '';
        // 上传头像预览地址
        const headpicUrl = computed({
            get: () => {
                return store.getters.userInfo.headpicUrl;
            },
        });

        const submitFlag = ref(false);
        const loading = ref(false);
        const updataShow = ref(false);
        /**
        * 打开弹框-开始
        */
        emitt.$sub('openModifyHeadImgModel', (val) => {
            ModelFlag.value = true;
        });
        onBeforeUnmount(() => {
            emitt.$unsub("openModifyHeadImgModel");
        });
        /**
         * 打开弹框-开始
         */

        /**
         * 上传头像-开始
         */
        function Update() {
            $('.upload-headImg').click()
            var eleFile = document.querySelector('.upload-headImg');
            var preview = document.querySelector('.example-headImg');
            eleFile.addEventListener('change', function () {
                var file = this.files[0];
                if (!file) return;
                // 确认选择的文件是图片
                if (file.type.indexOf("image") == 0) {
                    compressImg(file, 400).then(res => {
                        submitFlag.value = true;
                        document.getElementById('myImg').setAttribute('src', res.compressBase64)
                        headImgBase64 = res.compressBase64

                    }).catch(res => {
                        submitFlag.value = true;
                        document.getElementById('myImg').setAttribute('src', res.compressBase64)
                        headImgBase64 = res.compressBase64
                    })
                }
            });
        }
        /**
         * 上传头像-结束
         */

        /**
         * 提交-开始
         */
        function Confirm() {
            let params = {
                headpic: headImgBase64
            }
            loading.value = true;
            apiService.SetHeadpic(params).then(res => {
                if (res.status == 1) {
                    ModelFlag.value = false;
                    store.dispatch('getUserInfo');
                    ElMessage({
                        message: t('myAccount.text101'),
                        type: 'success',
                    });
                } else {
                    ElMessage({
                        message: res.message,
                        type: 'error',
                    });
                }
                loading.value = false;
            })
        }
        /**
         * 提交-开始
         */

        /**
         * 关闭弹框-开始
         */
        function beforeClose() {
            submitFlag.value = false;
            headImgBase64 = '';
        }
        /**
         * 关闭弹框-结束
         */
        return {
            ModelFlag,
            headpicUrl,
            submitFlag,
            loading,
            Confirm,
            updataShow,
            Update,
            beforeClose
        }
    }
}
</script>
<style lang="less">
.ModifyHeadImg {
    .modify_box {
        display: flex;
        justify-content: left;
    }

    .avatar {
        margin-right: 40px;
        /*no*/
        font-size: 14px;
        /*no*/
    }

    .headImg {
        position: relative;

        img {
            width: 80px;
            /*no*/
            height: 80px;
            /*no*/
            border-radius: 50%;
        }

        .update-avatar {
            background: rgba(0, 0, 0, 0.7);
            position: absolute;
            width: 80px;
            /*no*/
            height: 80px;
            /*no*/
            top: 0;
            left: 0;
            padding-top: 14px;
            /*no*/
            opacity: 0;
            border-radius: 50%;
            cursor: pointer;
            img {
                display: block;
                width: 30px;
                /*no*/
                height: 28px;
                /*no*/
                margin: 0 auto;
            }

            p {
                color: white;
                text-align: center;
                margin-top: 7px;
                /*no*/
            }
        }

        .opacity {
            opacity: 1;
        }

        .upload-headImg {
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
        }
    }
}
</style>
